// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"25771e21","323":"df8cd985","427":"7c9e81d7"}[chunkId] + ".chunk.js";
};